import { merge } from 'dot-prop-immutable';
import { CHANGE_COPY_DISABLED, INIT } from './actions';
import { Configurations } from '../models';

type Action = {
  type: typeof CHANGE_COPY_DISABLED | typeof INIT;
  payload: any;
};

export function constructorReducer(state: Configurations, action: Action): Configurations {
  const { type, payload } = action;

  switch (type) {
    case INIT:
      return payload;
    case CHANGE_COPY_DISABLED:
      return merge(state, 'disabledCopy', payload);
    default:
      return state;
  }
}
